//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";


export default {
  props: ["biodata_id", "nip"],
  data() {
    
    return {
      list_riwayat: [],
      angka_kredit :[],

      cekisAngkaKreditPertama:null,

      angkaKredit : {
     
        angka_kredit_id: '',
        pns : '',
        biodata_id: this.biodata_id,
        rwJabatan : '',
        bulanMulaiPenailan : '',
        bulanSelesaiPenailan : '',
        isAngkaKreditPertama : '',
        isIntegrasi : '0',
        isKonversi : '0',
        kreditBaruTotal : 0,
        kreditPenunjangBaru : 0,
        kreditUtamaBaru : 0,
        nomorSk : '',
        tahunMulaiPenailan : '',
        tahunSelesaiPenailan : '',
        tanggalSk : '',
        Sumber : '',
        created_at : '',
        updated_at : '',

        status : 1,
        file : null,
        userId : '',
        createdAt : '',
      },

      dummy : {
        jns_latihan_struktural_id : null,
      },

      listrwJabatan : [],

      mdl_detil_riwayat: false,
      mdl_detil_riwayat_add: false,
      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,
      file_old :'',

      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,

      btn_add: false,


      tab: 'disetujui',


      loadRiwayatSIA : true,
      fileLoadSIA :true,
      fileLoadEmpty : false,
      fileRiwayat : null,
      kodeDok : '880',


      status :1,



    };
  },

  methods: {
    getRiwayat: function(){

      this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_angka_kredit+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.angkaKredit.biodata_id,
              status : this.status
            })
        }).then((res) => res.json()).then((res_data) => {
          this.angka_kredit = res_data;
          console.log(this.angka_kredit);

          if(this.cekisAngkaKreditPertama == null){
            var cekisAngkaKreditPertama = this.angka_kredit.some(item => item.isAngkaKreditPertama === '1');
            this.cekisAngkaKreditPertama = cekisAngkaKreditPertama;


            if(this.cekisAngkaKreditPertama){

              this.angkaKredit.isAngkaKreditPertama = '';
            }else{

              this.angkaKredit.isAngkaKreditPertama = '1';
            }


          } 
          


          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    addData : function() {

      var formData = new FormData();
      formData.append('angka_kredit_id', this.angkaKredit.angka_kredit_id);
      formData.append('pnsId', this.angkaKredit.pns);
      formData.append('rwJabatanId', this.angkaKredit.rwJabatan);
      formData.append('bulanMulaiPenailan', this.angkaKredit.bulanMulaiPenailan);
      formData.append('bulanSelesaiPenailan', this.angkaKredit.bulanSelesaiPenailan);
      formData.append('isAngkaKreditPertama', this.angkaKredit.isAngkaKreditPertama);
      formData.append('isIntegrasi', this.angkaKredit.isIntegrasi);
      formData.append('isKonversi', this.angkaKredit.isKonversi);
      formData.append('kreditBaruTotal', this.angkaKredit.kreditBaruTotal);
      formData.append('kreditPenunjangBaru', this.angkaKredit.kreditPenunjangBaru);
      formData.append('kreditUtamaBaru', this.angkaKredit.kreditUtamaBaru);
      formData.append('nomorSk', this.angkaKredit.nomorSk);
      formData.append('tahunMulaiPenailan', this.angkaKredit.tahunMulaiPenailan);
      formData.append('tahunSelesaiPenailan', this.angkaKredit.tahunSelesaiPenailan);
      formData.append('tanggalSk', this.angkaKredit.tanggalSk);
      formData.append('Sumber', this.angkaKredit.Sumber);
      
      
      formData.append('biodata_id', this.angkaKredit.biodata_id);
      formData.append('nip', this.nip);
      formData.append('kode', this.kodeDok);



      formData.append('file', this.angkaKredit.file);

      fetch(this.$store.state.url.URL_simpeg_angka_kredit+'createData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then(res => res.json()).then(() => {
          this.getRiwayat();
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
      });
     
    },


    editData : function(){

      var formData = new FormData();
      
      formData.append('angka_kredit_id', this.angkaKredit.angka_kredit_id);
      formData.append('pnsId', this.angkaKredit.pns);
      formData.append('rwJabatanId', this.angkaKredit.rwJabatan);
      formData.append('bulanMulaiPenailan', this.angkaKredit.bulanMulaiPenailan);
      formData.append('bulanSelesaiPenailan', this.angkaKredit.bulanSelesaiPenailan);
      formData.append('isAngkaKreditPertama', this.angkaKredit.isAngkaKreditPertama);
      formData.append('isIntegrasi', this.angkaKredit.isIntegrasi);
      formData.append('isKonversi', this.angkaKredit.isKonversi);
      formData.append('kreditBaruTotal', this.angkaKredit.kreditBaruTotal);
      formData.append('kreditPenunjangBaru', this.angkaKredit.kreditPenunjangBaru);
      formData.append('kreditUtamaBaru', this.angkaKredit.kreditUtamaBaru);
      formData.append('nomorSk', this.angkaKredit.nomorSk);
      formData.append('tahunMulaiPenailan', this.angkaKredit.tahunMulaiPenailan);
      formData.append('tahunSelesaiPenailan', this.angkaKredit.tahunSelesaiPenailan);
      formData.append('tanggalSk', this.angkaKredit.tanggalSk);
      formData.append('Sumber', this.angkaKredit.Sumber);
      


      formData.append('biodata_id', this.angkaKredit.biodata_id);
      formData.append('nip', this.nip);
      formData.append('kode', this.kodeDok);

      formData.append('file', this.angkaKredit.file);
      formData.append('file_old', this.file_old);

      fetch(this.$store.state.url.URL_simpeg_angka_kredit+'updateData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then((res_data) => {
          this.getRiwayat();
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_simpeg_angka_kredit + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.angkaKredit.angka_kredit_id, file : this.file_old})
      }).then(res_data => {
          this.getRiwayat();
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
      });

    },

    selectRiwayat: function(data){


          this.angkaKredit.angka_kredit_id = data.angka_kredit_id;
          this.angkaKredit.pns = data.pns;
          this.angkaKredit.rwJabatan = data.rwJabatan;
          this.angkaKredit.bulanMulaiPenailan = data.bulanMulaiPenailan;
          this.angkaKredit.bulanSelesaiPenailan = data.bulanSelesaiPenailan;
          this.angkaKredit.isAngkaKreditPertama = data.isAngkaKreditPertama;
          this.angkaKredit.isIntegrasi = data.isIntegrasi;
          this.angkaKredit.isKonversi = data.isKonversi;
          this.angkaKredit.kreditBaruTotal = data.kreditBaruTotal;
          this.angkaKredit.kreditPenunjangBaru = data.kreditPenunjangBaru;
          this.angkaKredit.kreditUtamaBaru = data.kreditUtamaBaru;
          this.angkaKredit.nomorSk = data.nomorSk;
          this.angkaKredit.tahunMulaiPenailan = data.tahunMulaiPenailan;
          this.angkaKredit.tahunSelesaiPenailan = data.tahunSelesaiPenailan;
          this.angkaKredit.tanggalSk = data.tanggalSk;
          this.angkaKredit.Sumber = data.Sumber;
          this.angkaKredit.created_at = data.created_at;
          this.angkaKredit.updated_at = data.updated_at;
          


          this.angkaKredit.status = data.status;
          this.angkaKredit.createdAt = data.createdAt;


          if (data.status != 1) {
            this.fileLoadSIA = false
            this.file_old = data.path[this.kodeDok].realname;
          }

          

    },


    updatekreditUtamaBaru() {
      this.angkaKredit.kreditBaruTotal = +this.angkaKredit.kreditUtamaBaru + +this.angkaKredit.kreditPenunjangBaru
    },
    uodatekreditPenunjangBaru() {
        this.angkaKredit.kreditBaruTotal = +this.angkaKredit.kreditUtamaBaru + +this.angkaKredit.kreditPenunjangBaru
    },





    // ====================================== INTEGRASI SI-ASN ====================================

    listJabatanbyNIP: function(){

      // this.loadRiwayatSIA = true;


      fetch(this.$store.state.url.URL_simpeg_angka_kredit+'listJabatanbyNIP', {
          method : 'POST',
          headers : {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body : JSON.stringify({
            nip : this.nip,
            biodata_id : this.biodata_id,
            kode : this.kodeDok,
          })
      }).then((res) => res.json()).then((res_data) => {
        this.listrwJabatan = res_data.data;
        
        console.log(this.listrwJabatan); 
        
        // this.getRiwayat();

      })
    },

    syncDataRiwayatSiASN: function(){

        this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_angka_kredit+'si_asn_viewOne', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              nip : this.nip,
              biodata_id : this.biodata_id,
              kode : this.kodeDok,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.Notify('Sukses Sync Data', 'warning', 'check_circle_outline');


          this.getRiwayat();

          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    approveUsulanDataRiwayatSiASN : async function(){


      this.angkaKredit.nip = this.nip
      this.angkaKredit.kode = this.kodeDok
      this.angkaKredit.file_old = this.file_old


      console.log(this.angkaKredit);

      var sex = await UMUM.alertConfirm("Apakah anda ingin Approve Usulan?")

      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_angka_kredit + "approve", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.angkaKredit)
        }).then(res_data => {
            this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },

    kembalikan : async function(){
          
          
          this.angkaKredit.nip = this.nip
          this.angkaKredit.kode = this.kodeDok
          this.angkaKredit.file_old = this.file_old


          console.log(this.angkaKredit);

          var sex = await UMUM.alertConfirm("Apakah anda ingin Approve Usulan?")

          if (sex.isConfirmed) {


            fetch(this.$store.state.url.URL_simpeg_angka_kredit + "approve", {
                method: "POST",
                headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.angkaKredit)
            }).then(res_data => {
                this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
                this.getRiwayat();
            });


                  
          }
    },

    deleteDataRiwayatSiASN : async function(){


      this.angkaKredit.nip = this.nip
      this.angkaKredit.kode = this.kodeDok
      // console.log(this.angkaKredit);

      var sex = await UMUM.alertConfirm("Apakah anda ingin menghapus riwayat?")


      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_angka_kredit + "si_asn_delete", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.angkaKredit)
        }).then(res_data => {
            this.Notify('Sukses menghapus Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },


    getDownloadSIASN: async function(file,kode) {


      console.log("ppppppppp");
      console.log(file);
      console.log("ppppppppp");

              
      if (file.path == null || file.path == undefined) {
        this.fileLoadEmpty = true
        console.log("FILE KOSONG");
      } else {
        this.fileLoadEmpty = false


        console.log(file);
        
        var fileGet = file.path[kode].dok_uri
        this.fileLoadSIA = true
        fetch(this.$store.state.url.URL_simpeg_home + "lampiran", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                fileURL: fileGet,
                id : file.angka_kredit_id,
                kode : this.kodeDok,
            })
            })
            .then(response => response.text())
            .then(res_data => {


                console.log("INI DIA");
                console.log(res_data)
                console.log("INI DIA");
                console.log(typeof(res_data));

                this.fileRiwayat = res_data
                this.fileLoadSIA = false

              

        });

      }


    },







    // ====================================== INTEGRASI SI-ASN ====================================



    alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
    },
    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },

  },


  mounted () {
    this.getRiwayat();
    this.listJabatanbyNIP();
    DATA_MASTER.getGolongan();
    DATA_MASTER.getJnsDiklat();
    DATA_MASTER.getLatStruktural();
    DATA_MASTER.getJnsKompetensi();
  },



};
